module.exports = __webpack_public_path__ + "static/media/mute_club_2.d97ec306.png";